import { useContext } from 'react'
import { CheckoutContext } from '../context/CheckoutContext'
import type { CheckoutContextType } from '../context'

export const useCheckoutContext = (): CheckoutContextType => {
  const ctx = useContext(CheckoutContext)

  if (!ctx) {
    throw Error('No context provider was found. Wrap your app with the CheckoutContextProvider')
  }

  return { ...ctx }
}
